var style = {"z-box":"z-box","z-brand-theme-zooplus":"z-brand-theme-zooplus","z-brand-theme-bitiba":"z-brand-theme-bitiba","z-box--bold":"z-box--bold","z-box--secondary":"z-box--secondary","z-box--neutral":"z-box--neutral","z-box--success":"z-box--success","z-box--warning":"z-box--warning","z-box--danger":"z-box--danger"};

export { style as default };
//# sourceMappingURL=Box.module.scss.js.map
